/* eslint-disable no-prototype-builtins */
/* eslint-disable no-undef */
import ClearBitIntegration from './clearbit-integration';
const AjaxCpt = {
  taxonomyTerms: {},
  page: 1,
  // Utility Functions
  extractTaxonomyTermsFromURL: () => {
    const currentURL = new URL(window.location.href);
    const searchParams = currentURL.searchParams;
    const taxonomyTerms = {};

    searchParams.forEach((value, key) => {
      if (key.startsWith('taxonomy[')) {
        const taxonomy = key.substring(9, key.length - 1); // Extract the taxonomy name
        taxonomyTerms[taxonomy] = value;
      }
    });

    return taxonomyTerms;
  },
  updateTotalResultsText: (totalPosts, loadedPosts, $totalResults) => {
    const $postList = $('.post-list');
    const postsPerPage = parseInt($postList.data('posts-per-page'));
    $totalResults.text(`Showing ${(AjaxCpt.page - 1) * postsPerPage + loadedPosts} out of ${totalPosts}`);
  },

  showLoadingText: ($loadingText) => {
    $loadingText.show();
  },

  hideLoadingText: ($loadingText) => {
    $loadingText.hide();
  },

  showLoadMoreButton: ($loadMoreButton) => {
    $loadMoreButton.show();
  },

  hideLoadMoreButton: ($loadMoreButton) => {
    $loadMoreButton.hide();
  },

  disableLoadMoreButton: ($loadMoreButton) => {
    $loadMoreButton.addClass('disabled'); // Add a CSS class to disable button
    $loadMoreButton.prop('disabled', true); // Disable the button
  },

  enableLoadMoreButton: ($loadMoreButton) => {
    $loadMoreButton.removeClass('disabled'); // Remove the CSS class to enable button
    $loadMoreButton.prop('disabled', false); // Enable the button
  },

  loadPosts: (loading, $loadMoreButton, $postList, postType, postsPerPage, $loadingText, $totalResults, taxonomyTerms, isFirstLoad) => {
    if (loading) return;
    loading = true;
    const ajaxurl = wpCustomVariables.ajaxUrl;
    const args = {
      action: 'load_posts',
      page: AjaxCpt.page,
      taxonomy: taxonomyTerms,
      post_type: postType,
      posts_per_page: postsPerPage,
      template: $postList.data('template'),
      parent_post_id: wpCustomVariables.postId,
    };
    // Show loading text only when an AJAX request is initiated
    AjaxCpt.showLoadingText($loadingText);
    $('.custom-list-filter__wrapper').addClass('filter-content-loading');
    $('.filter-tax-wrapper').addClass('filters-option-loading');

    $.ajax({
      url: ajaxurl,
      type: 'post',
      data: args,
      success: (response) => {
        $('.custom-list-filter__wrapper').removeClass('filter-content-loading');
        $('.filter-tax-wrapper').removeClass('filters-option-loading');

        if (response.post_count === 0) {
          // Clear the existing results in the post list.
          $postList.empty();
          $('body, html').animate(
            {
              scrollTop: $postList.offset().top,
            },
            'fast'
          );
          AjaxCpt.updateTotalResultsText(0, response.post_count, $totalResults);
        }

        if (response.posts) {
          $postList.append(response.posts);
          AjaxCpt.updateTotalResultsText(response.total_posts || 0, response.post_count, $totalResults);
          ClearBitIntegration.onInit();
          // page++;
        }
        loading = false;

        // Hide loading text when the request is completed
        AjaxCpt.hideLoadingText($loadingText);

        if (response.max_num_pages <= AjaxCpt.page) {
          AjaxCpt.disableLoadMoreButton($loadMoreButton);
          AjaxCpt.hideLoadMoreButton($loadMoreButton);
        } else {
          AjaxCpt.showLoadMoreButton($loadMoreButton);
          AjaxCpt.enableLoadMoreButton($loadMoreButton);
        }
      },
    });
  },

  handleFilterItemClick: function (e) {
    e.preventDefault();
    const taxonomy = $(this).data('taxonomy');
    const termId = $(this).data('category');
    const postType = $(this).data('posttype');
    const $loadMoreButton = $('.load-more-button');
    const $postList = $('.post-list');
    const $loadingText = $('.filter-loading-text');
    const $totalResults = $('.total-results');
    const postsPerPage = $postList.data('posts-per-page');
    AjaxCpt.hideLoadMoreButton($loadMoreButton);
    // Reset the page to 1
    AjaxCpt.page = 1;
    $postList.empty();

    // Create a URLSearchParams object to read existing URL parameters for eg user is on page with only 1 filter (of taxonomy) selected and hit refresh. In that case the first value should be picked from the url and in case user clicks on second filter(different taxonomy) 2 taxonomies should be passed.
    const currentURL = new URL(window.location.href);
    const searchParams = currentURL.searchParams;

    // Update the URL with the selected terms, preserving existing query parameters
    const taxonomyTerms = AjaxCpt.extractTaxonomyTermsFromURL();
    // Check if the clicked term is already in the AjaxCpt.taxonomyTerms

    if (parseInt(taxonomyTerms[taxonomy]) === parseInt(termId)) {
      // Term is already selected, so remove it and mark it as inactive
      delete taxonomyTerms[taxonomy];
      searchParams.delete(`taxonomy[${taxonomy}]`); // Remove the term from the URL
      // Remove the active class from the clicked item
      $(this).removeClass('active');
    } else {
      // Term is not selected, so add it and mark it as active
      taxonomyTerms[taxonomy] = termId;
      // Deactivate any previously active items within the same taxonomy
      $(`.js-filter-item[data-taxonomy="${taxonomy}"]`).removeClass('active');

      // Update the clicked item to be active
      $(this).addClass('active');
    }

    // Update the URL with the selected terms
    for (const key in taxonomyTerms) {
      if (taxonomyTerms.hasOwnProperty(key)) {
        const value = taxonomyTerms[key];
        searchParams.set(`taxonomy[${key}]`, value);
      }
    }

    // Create the new URL with updated query parameters
    const newURL = `${currentURL.pathname}?${searchParams.toString()}`;

    // Update the URL without triggering a page reload
    window.history.pushState({}, '', newURL);

    // Call the AJAX function with the selected taxonomy terms
    AjaxCpt.loadPosts(false, $loadMoreButton, $postList, postType, postsPerPage, $loadingText, $totalResults, taxonomyTerms, false);
  },
  onFilterItemClick: () => {
    const currentURL = new URL(window.location.href);

    // Construct the query string from the taxonomyTerms object
    const queryString = Object.entries(AjaxCpt.taxonomyTerms)
      .map(([taxonomy, termId]) => `taxonomy[${taxonomy}]=${termId}`)
      .join('&');

    // Update the URL without triggering a page reload
    window.history.pushState({}, '', `${currentURL.pathname}?${queryString}`);
  },

  onInit: () => {
    (function ($) {
      let loading = false;
      const $loadMoreButton = $('.load-more-button');
      const $postList = $('.post-list');
      const postType = $postList.data('post-type');
      const postsPerPage = $postList.data('posts-per-page');
      const $loadingText = $('.filter-loading-text');
      const $totalResults = $('.total-results'); // Add this line

      // Get URL parameters using JavaScript URLSearchParams
      const urlParams = new URLSearchParams(window.location.search);
      // Initialize an object to store taxonomy terms
      const taxonomyTerms = AjaxCpt.extractTaxonomyTermsFromURL();

      // Event handler for clicking the "Load More" button
      $loadMoreButton.on('click', () => {
        $loadMoreButton.prop('disabled', true);
        AjaxCpt.page++; // Increment the page value
        const taxonomyTerms = AjaxCpt.extractTaxonomyTermsFromURL();
        AjaxCpt.loadPosts(loading, $loadMoreButton, $postList, postType, postsPerPage, $loadingText, $totalResults, taxonomyTerms, false);
      });

      // Initial load of posts
      AjaxCpt.loadPosts(loading, $loadMoreButton, $postList, postType, postsPerPage, $loadingText, $totalResults, taxonomyTerms, true);

      /* On Filter Click */
      $('.js-filter-item').on('click', AjaxCpt.handleFilterItemClick);
    })(jQuery);
  },
};

export default AjaxCpt;
